var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.field.items,"label":_vm.field.label,"menu-props":{ light: true},"placeholder":" ","multiple":"","clearable":"","disabled":false},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }